import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../../features/auth/store/authSlice';
import templatesReducer from '../../features/templates/store/templatesSlice';
import campaignCadencesReducer from '../../features/campaign-cadences/store/campaignCadencesSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  templates: templatesReducer,
  campaignCadences: campaignCadencesReducer,
});

export default rootReducer;
